export default __webpack_public_path__ + "static/media/circle.7ac594f8.svg";